import get from '@pkg/utils/objects/get';
import { SortOrder } from '@/lib/enums';

/**
 * @param {String} property
 * @returns {Function}
 */
export default function alpha(property, sortOrder = SortOrder.ASC) {
  const isAscending = sortOrder === SortOrder.ASC;
  return (a, b) => {
    const first = isAscending ? a : b;
    const second = isAscending ? b : a;
    return get(first, property, '')
      .toString()
      .localeCompare(get(second, property, ''))
      .toString();
  };
}
